import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Button, Form } from "react-bootstrap";
import { plansService } from "../services/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const defaultForm = {
  code: "",
  name: "",
  price: "0",
  currency: "TRY",
  plan_interval: "monthly",
  interval_count: "1",
  trial_days: "0",
  notification_sms_limit: "0",
  notification_email_limit: "0",
  notification_whatsapp_limit: "0",
  file_storage_limit_gb: "0",
  enabled_modules_text: '["appointments","customers"]',
  is_active: true,
};

const PlanCreatePage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState(defaultForm);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    let modulesParsed;
    try {
      modulesParsed = JSON.parse(form.enabled_modules_text || "[]");
      if (!Array.isArray(modulesParsed)) {
        toast.error("Modüller geçerli bir JSON dizi olmalıdır");
        return;
      }
    } catch {
      toast.error("Modül JSON'u geçersiz");
      return;
    }

    setSaving(true);
    const payload = {
      code: form.code.trim(),
      name: form.name.trim(),
      price: parseFloat(form.price) || 0,
      currency: form.currency.trim(),
      plan_interval: form.plan_interval,
      interval_count: parseInt(form.interval_count, 10) || 1,
      trial_days: parseInt(form.trial_days, 10) || 0,
      notification_sms_limit: parseInt(form.notification_sms_limit, 10) || 0,
      notification_email_limit: parseInt(form.notification_email_limit, 10) || 0,
      notification_whatsapp_limit:
        parseInt(form.notification_whatsapp_limit, 10) || 0,
      file_storage_limit_gb: parseInt(form.file_storage_limit_gb, 10) || 0,
      enabled_modules: modulesParsed,
      is_active: form.is_active ? 1 : 0,
    };

    if (!payload.code || !payload.name) {
      setSaving(false);
      toast.error("Kod ve ad zorunludur");
      return;
    }

    const res = await plansService.createPlan(payload);
    setSaving(false);
    if (res.success) {
      toast.success("Plan oluşturuldu");
      navigate("/plans/list");
    } else {
      toast.error(res.message || res.error || "Plan oluşturulamadı");
    }
  };

  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Plan Oluştur" />
      <div className="dashboard-main active">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title mb-4">Yeni plan</h5>
              <Form onSubmit={submit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <Form.Label>Kod (benzersiz)</Form.Label>
                    <Form.Control
                      required
                      value={form.code}
                      onChange={(e) =>
                        setForm({ ...form, code: e.target.value })
                      }
                      placeholder="ornek_pro"
                    />
                  </div>
                  <div className="col-md-6">
                    <Form.Label>Görünen ad</Form.Label>
                    <Form.Control
                      required
                      value={form.name}
                      onChange={(e) =>
                        setForm({ ...form, name: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Label>Fiyat</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      value={form.price}
                      onChange={(e) =>
                        setForm({ ...form, price: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Label>Para birimi</Form.Label>
                    <Form.Control
                      value={form.currency}
                      onChange={(e) =>
                        setForm({ ...form, currency: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Label>Plan aralığı</Form.Label>
                    <Form.Select
                      value={form.plan_interval}
                      onChange={(e) =>
                        setForm({ ...form, plan_interval: e.target.value })
                      }
                    >
                      <option value="monthly">monthly</option>
                      <option value="yearly">yearly</option>
                      <option value="trial">trial</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <Form.Label>Aralık çarpanı</Form.Label>
                    <Form.Control
                      type="number"
                      value={form.interval_count}
                      onChange={(e) =>
                        setForm({ ...form, interval_count: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Label>Deneme günü</Form.Label>
                    <Form.Control
                      type="number"
                      value={form.trial_days}
                      onChange={(e) =>
                        setForm({ ...form, trial_days: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-4 d-flex align-items-end">
                    <Form.Check
                      type="switch"
                      id="create-plan-active"
                      label="Vitrinde listelensin"
                      checked={form.is_active}
                      onChange={(e) =>
                        setForm({ ...form, is_active: e.target.checked })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Label>Bildirim SMS limit</Form.Label>
                    <Form.Control
                      type="number"
                      value={form.notification_sms_limit}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          notification_sms_limit: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Label>Bildirim e-posta limit</Form.Label>
                    <Form.Control
                      type="number"
                      value={form.notification_email_limit}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          notification_email_limit: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Label>Bildirim WhatsApp limit</Form.Label>
                    <Form.Control
                      type="number"
                      value={form.notification_whatsapp_limit}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          notification_whatsapp_limit: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Label>Dosya depolama (GB)</Form.Label>
                    <Form.Control
                      type="number"
                      value={form.file_storage_limit_gb}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          file_storage_limit_gb: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-12">
                    <Form.Label>enabled_modules (JSON dizi)</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={6}
                      className="font-monospace small"
                      value={form.enabled_modules_text}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          enabled_modules_text: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="mt-4 d-flex gap-2">
                  <Button type="submit" variant="primary" disabled={saving}>
                    {saving ? "Kaydediliyor…" : "Planı oluştur"}
                  </Button>
                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={() => navigate("/plans/list")}
                  >
                    Listeye dön
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default PlanCreatePage;
